//CSS
import "../../Components/Page/Page.css";

//React
import React from "react";
import SecHeader from "../../Components/SecHeader/SecHeader";
import SubSection from "../../Components/Section/SubSection";
//Data
import VdoCipherComp from "../../Components/VdoCipher/VdoCipher";

const EngineModeling: React.FC = () => {
    return (
        <div id="Goals" className="sectionContainer">
            <SecHeader title="Engine Modeling" />
            
            <SubSection isSplit={false}>
                <div className="description-container">
                    <p>
                        <b>CFD Simulations</b>
                        <ul>
                            <li>We use Siemens Star CCM+ to run computational fluid dynamics (CFD) simulations of our proprietary engine geometries.</li>
                            <li>These simulations help compute cylinder pressures, temperatures, power, efficiency, emissions, airflow, and more.</li>
                            <li>These “SIMs” validate our E-SPEC software's starting designs for costumers and help us iterate to new engines and parts.</li>
                        </ul>
                    </p>{" "}
                    <p>
                        <b>Stress Analysis</b>
                        <ul>
                            <li>SolidWorks SIMs are used for failure analyses on load bearing components such as crankshafts and connecting rods.</li>
                            <li>Combining SolidWorks & Siemens’ SIMs plus our E-SPEC design software ensures our designs are fit for the tasks.</li>
                        </ul>
                    </p>{" "}
                    <p>
                        <b>Engine Balance Analysis</b>
                        <ul>
                            <li>Our balancing software applications show the superior engine balance seen in our new designs.</li>
                            <li>For all designs, the software calculates optimal counter-balancing steps.</li>
                        </ul>
                    </p>{" "}
                    
                </div>
            </SubSection>
            {/* <SubSection>
                
                <VdoCipherComp filename="eta4k"/>
            </SubSection> */}

        </div>
    );
};

export default EngineModeling;